import { SvgIcon } from './svg-icon';
import { ComponentSvgIconProps, SvgIconProps } from './svg-icon.d';
import { mergeProps } from 'solid-js';

const defaultProps: SvgIconProps = {
    viewBox: '0 0 24 24',
    fill: 'currentColor',
    defaultAriaLabel: 'Chevron Right Icon',
};

export const ChevronRightIcon = (componentProps: ComponentSvgIconProps) => {
    const props = mergeProps(defaultProps, componentProps);

    return (
        <SvgIcon {...props}>
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M17.688 11.9999C17.688 12.259 17.585 12.5076 17.4018 12.6908L10.5396 19.5529C10.158 19.9345 9.53935 19.9345 9.15775 19.5529C8.77615 19.1713 8.77615 18.5527 9.15775 18.1711L15.329 11.9999L9.15775 5.82874C8.77615 5.44714 8.77615 4.82845 9.15774 4.44685C9.53934 4.06525 10.158 4.06524 10.5396 4.44684L17.4018 11.3089C17.585 11.4922 17.688 11.7407 17.688 11.9999Z"
            />
        </SvgIcon>
    );
};
